import { TradeBuyComponent } from "@modules/trade/modals/trade-buy-modal/trade-buy-modal.component";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { TradeSellComponent } from "@modules/trade/modals/trade-sell-modal/trade-sell.component";
import { ACTION_BUTTONS } from "@modules/action-buttons/entities/action-button.enum";

export const TRADE_ACTION = {
	[ACTION_BUTTONS.BUY]: {
		component: TradeBuyComponent,
		type: TRADE_TYPE.BUY
	},
	[ACTION_BUTTONS.SELL]: {
		component: TradeSellComponent,
		type: TRADE_TYPE.SELL
	}
};
